export const toolTipText = (theme) => {
    return {
        width: '130px',
        backgroundColor: `${theme.font.regular}50`,
        color: theme.primary,
        textAlign: 'center',
        borderRadius: '6px',
        padding: '5px 0',
        position: 'absolute',
        zIndex: 1,
        fontSize: '0.9em',
    }
}